import { render, staticRenderFns } from "./IncludedEnvironments.vue?vue&type=template&id=0494493e&"
import script from "./IncludedEnvironments.vue?vue&type=script&lang=js&"
export * from "./IncludedEnvironments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports